module.exports = __webpack_public_path__ + "static/img/thumb-03.9f1e330.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/shipping-label/thaipost/thumb/thumb-03.png
// module id = LiMW
// module chunks = 150